import { gql } from "@apollo/client";


export const CREATE_INVOICE_CREDIT = gql`
mutation ClaimCredit($data: WalletInput!) {
    claimCredit(data: $data) {
      message
    }
  }
`
 

export const CANCELED_INVOICE_CREDIT = gql`
mutation CancelClaimCredit($where: WalletInput) {
  cancelClaimCredit(where: $where) {
    message
  }
}
`

export const FINESHED_INVOICES_CREDIT = gql`
mutation ConfirmFinishedInvoice($where: WalletInput) {
  confirmFinishedInvoice(where: $where) {
    message
  }
}
`

export const APPROVING_INVOICES_CREDIT = gql`
mutation ApprovedInvoiceClaimCredit($data: WalletInput!, $where: WalletWhereInput) {
  approvedInvoiceClaimCredit(data: $data, where: $where) {
    message
  }
}
`
export const APPROVING_INVOICES_CREDIT_V2 = gql`
mutation ApprovedInvoiceClaimCreditV2($data: WalletInput!, $where: WalletWhereInput) {
  approvedInvoiceClaimCreditV2(data: $data, where: $where) {
    message
    msg
    status
    tag
    err
  }
}
`

